import React from 'react'
import { Endpoint } from './Card'

export type KPITone = 'flat' | 'up' | 'down'

export function KPI({
  label,
  value,
  delta,
  tone = 'flat',
  endpoint,
  sub,
}: {
  label: string
  value: React.ReactNode
  delta?: React.ReactNode
  tone?: KPITone
  endpoint?: string
  sub?: React.ReactNode
}) {
  return (
    <div className="kpi">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <span className="label">{label}</span>
        {endpoint && <Endpoint>{endpoint}</Endpoint>}
      </div>
      <div className="val">{value}</div>
      {(delta || sub) && (
        <div className="row" style={{ gap: 6 }}>
          {delta && <span className={`delta ${tone}`}>{delta}</span>}
          {sub && <span className="delta flat">{sub}</span>}
        </div>
      )}
    </div>
  )
}
